/* eslint-disable no-restricted-imports */
import {
  MutationInput_UserController_UpdateById_Input_RoleName as RoleNameApi1,
  MutationInput_UserController_CreateOne_Input_RoleName as RoleNameApi2,
} from 'api/generated/graphql';
import { RoleType } from 'api/types/entity';

type RoleNameApi = RoleNameApi1 | RoleNameApi2;

const roles: Record<RoleType, RoleNameApi | undefined> = {
  [RoleType.Admin]: RoleNameApi1.Admin,
  [RoleType.BackOffice]: RoleNameApi1.BackOffice,
  [RoleType.ComplianceOfficer]: RoleNameApi1.ComplianceOfficer,
  [RoleType.LegalOfficer]: RoleNameApi1.LegalOfficer,
  [RoleType.MiddleOffice]: RoleNameApi1.MiddleOffice,
  [RoleType.RiskManager]: RoleNameApi1.RiskManager,
  [RoleType.FrontOffice]: RoleNameApi1.FrontOffice,
  [RoleType.SettlementSpecialist]: RoleNameApi1.SettlementSpecialist,
  [RoleType.Superadmin]: undefined,
};

export const parseRole = (role: RoleType): RoleNameApi | undefined =>
  roles[role];
